<sim-basic-material-dialog
	(closeClicked)="
		close({
			uploadedFiles: uploadedFiles,
			action: 'ok',
		})
	"
	[finished]="finished"
	[matDialogData]="data"
	[rect]="rect"
	[headerText]="T.USER_MANAGER_UPLOAD_USERS_DIALOG_TITLE | translate"
	[headerIcon]="{fontIcon: 'fa-upload', fontSet: 'fad'}"
	class="normalDuotoneHeaderIcon"
	[overflowHandledByChild]="true"
>
	<ng-container dialogContent>
		<input
			type="file"
			[accept]="acceptedFileTypesText"
			multiple
			id="upload"
			#uploadInput
			hidden="hidden"
			(change)="handleFileInput($event)"
		/>

		<div>
			<sim-tags-chip-input [tagType]="TagType.SimUser" (onChange)="updateTags($event)" />
		</div>

		<div>
			<section>
				<div class="mat-h2 checklistRoleHeader">{{ T.USER_MANAGER_UPLOAD_USERS_DIALOG_ROLE_TO_BE_SET_INFO | translate }}</div>
				<div class="checklistOptions">
					@for (role of simRole; track role; let even = $even; let odd = $odd; let last = $last) {
						@if (
							!(
								role.id === "Technician" &&
								currentUser?.roleIds.includes("Admin") &&
								!currentUser?.roleIds.includes("Technician")
							)
						) {
							<div class="checklistRow">
								<p>
									<mat-checkbox (change)="roleChanged(role.id, $event)" [checked]="checkedRoles.includes(role.id)">
										{{ role.name }}
									</mat-checkbox>
								</p>
							</div>
						}
					}
				</div>
			</section>
		</div>

		@if (currentSelectedFiles && currentSelectedFiles?.length !== 0) {
			<div class="previewFiles">
				<div class="filePreviewList">
					@for (currentSelectedFile of currentSelectedFiles; track currentSelectedFile; let i = $index) {
						<div class="previewFile" [@anim]="'active'">
							<sim-media-card-list
								[previewMedia]="true"
								[previewMediaType]="type"
								[mediaName]="currentSelectedFile.name"
								[active]="currentSelectedFile?.isPlaying"
								[progress]="currentSelectedFile?.progress"
								[currentSelectedFile]="currentSelectedFile"
								[showDeleteButton]="true"
								[previewMediaUrl]="currentSelectedFile.mediaUrl"
								[isUploading]="currentSelectedFile.isUploading"
								[uploadProgress]="currentSelectedFile.progressUploading"
							/>
						</div>
					}
				</div>
			</div>
		}

		@if (importErrors) {
			<div>
				@for (importError of importErrors | keyvalue; track importError) {
					<div>{{ T.USER_MANAGER_UPLOAD_USERS_DIALOG_ROW_TEXT | translate }} {{ importError.key }} - {{ importError.value }}</div>
				}
			</div>
		}

		<div class="uploadFilesFirst">
			<div class="uploadBtn">
				<button
					mat-raised-button
					[color]="currentSelectedFiles && currentSelectedFiles.length !== 0 ? 'warn' : 'accent'"
					(click)="selectFile()"
				>
					{{
						(currentSelectedFiles && currentSelectedFiles.length !== 0
							? T.UPLOAD_MEDIA_DIALOG_CLEAR_SELECTION
							: T.UPLOAD_MEDIA_DIALOG_CHOOSE_FILE
						) | translate
					}}
				</button>
				<button
					class="uploadToSimStation"
					(click)="uploadFiles()"
					mat-raised-button
					color="accent"
					[hidden]="!currentSelectedFiles || currentSelectedFiles?.length === 0"
				>
					{{ T.UPLOAD_MEDIA_DIALOG_BUTTON | translate }}
				</button>
			</div>

			@if (afterViewInit && !currentSelectedFiles) {
				<div
					class="uploadHint"
					[@zoomInOnEnter]
					[@zoomOutOnLeave]
					[innerHTML]="(T.UPLOAD_MEDIA_DIALOG_HINTS | translate) + acceptedFileTypes"
				></div>
			}

			<a href="/Content/media/template/UserImport.xlsx">{{ T.UPLOAD_USER_EXCEL_TEMPLATE | translate }}</a>
		</div>
	</ng-container>
</sim-basic-material-dialog>
